import { render, staticRenderFns } from "./data87.vue?vue&type=template&id=4a1f6ce6&scoped=true&"
import script from "./data87.vue?vue&type=script&lang=js&"
export * from "./data87.vue?vue&type=script&lang=js&"
import style1 from "./data87.vue?vue&type=style&index=1&id=4a1f6ce6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1f6ce6",
  null
  
)

export default component.exports